
<!-- ------------------------------------------------------- -->
 <div class="container" style=" display: flex;justify-content: center;">
<div class="employee-card" *ngIf="employee; else loading" >
        <div class="card-header">
            <div class="employee-image">
               <img
              *ngIf="employee.image; else noImage"
              [src]="employee.image"
               alt="Employee Image"
              class="img-thumbnail mt-2"
              style="width: 120px; height: 120px; object-fit: cover; border-radius: 50%; border: 3px solid rgb(160 110 0);"
            />
             
               
            </div>
            <ng-template #noImage>
               <i class="fas fa-user"></i>
            </ng-template>
            <h1 class="employee-name">{{ employee.name || 'N/A' }}</h1>
            <p class="employee-title">{{ 'MENU.DASHBOARD.employee' | translate }}</p>
<span class="status-badge" [ngClass]="employee.is_active ? 'bg-success' : 'bg-danger'">
  {{ employee.is_active ? ('MENU.DASHBOARD.Active' | translate) : ('MENU.DASHBOARD.inActive' | translate) }}
</span>        </div>
        
        <div class="card-body">
          
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-envelope"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.email' | translate }} : </div>
                    <div class="info-value">{{ employee.email || 'N/A' }}</div>
                </div>
            </div>
             <div class="divider"></div>
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-phone"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label">{{ 'MENU.DASHBOARD.phone' | translate }} : </div>
                    <div class="info-value">{{ employee.phone_without_code || 'N/A' }}</div>
                </div>
            </div>
            
           
           
            
            <div class="divider"></div>
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.job_title' | translate }}: </div>
                    <div class="info-value">{{ employee.job_title?.name || 'N/A' }} </div>
                </div>
            </div>
            
            <!-- <div class="divider"></div> -->
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-globe-asia"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label">{{ 'MENU.DASHBOARD.nationality' | translate }} : </div>
                    <div class="info-value">{{ employee.nationality || 'N/A' }}</div>
                </div>
            </div>
             <div class="divider"></div>
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-city"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.city' | translate }}: </div>
                    <div class="info-value"> {{ currentLang === 'ar'? employee.city?.name_ar: employee.city?.name_en }}</div>
                </div>
            </div>
             <div class="divider"></div>
             <div class="info-group">
                <div class="info-icon">
                     <i class="fas fa-id-card"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label">{{ 'MENU.DASHBOARD.id_number' | translate }} : </div>
                    <div class="info-value">{{ employee.identity_number || 'N/A' }}</div>
                </div>
            </div>
        </div>
        
</div>

<!-- Investors Section - Separate Component -->
<div class="investors-section mx-2" *ngIf="employee?.investors && employee.investors.length > 0">
    <div class="section-header">
        <div class="section-icon">
            <i class="fas fa-users"></i>
        </div>
        <h2 class="section-title mx-1 ">{{ 'MENU.DASHBOARD.investors' | translate }}</h2>
        <span class="investors-count">{{ employee.investors.length }} {{ 'MENU.DASHBOARD.investors' | translate }}</span>
    </div>

    <div class="investors-grid">
        <div class="investor-card" *ngFor="let investor of employee.investors">
            <div class="investor-header">
                <div class="investor-avatar">
                    <img *ngIf="investor.image" 
                         [src]="investor.image" 
                         alt="Investor Image"
                         class="investor-image"
                         >
                    <div *ngIf="!investor.image" class="investor-avatar-placeholder">
                        <i class="fas fa-user-tie"></i>
                    </div>
                </div>
                <div class="investor-basic-info">
                    <h3 class="investor-name">{{ investor.name || 'N/A' }}</h3>
                    <p class="investor-email">
                        <i class="fas fa-envelope"></i>
                        {{ investor.email || 'N/A' }}
                    </p>
                </div>
            </div>

            <div class="investor-details">
                <div class="detail-item">
                    <div class="detail-icon">
                        <i class="fas fa-phone"></i>
                    </div>
                    <div class="detail-content mx-1">
                        <span class="detail-label">{{ 'MENU.DASHBOARD.phone' | translate }}:</span>
                        <span class="detail-value">{{ investor.phone_without_code || 'N/A' }}</span>
                    </div>
                </div>
           <!-- <div class="detail-item">
                  <div class="detail-icon">
                      <i class="fas fa-id-card"></i>
                  </div>
                  <div class="info-content mx-1">
                      <div class="info-label">{{ 'MENU.DASHBOARD.id_number' | translate }} : </div>
                      <div class="info-value">{{ employee.identity_number || 'N/A' }}</div>
                  </div>
              </div> 
               <div class="detail-item">
                    <div class="detail-icon">
                        <i class="fas fa-globe-asia"></i>
                    </div>
                    <div class="detail-content mx-1">
                        <span class="detail-label">{{ 'MENU.DASHBOARD.nationality' | translate }}:</span>
                        <span class="detail-value">{{ investor.nationality || 'N/A' }}</span>
                    </div>
                </div>  -->

                
            </div>

            <div class="investor-footer">
                <span class="status-badge" [ngClass]="employee.is_active ? 'bg-success' : 'bg-danger'">
                     {{ investor.is_active ? ('MENU.DASHBOARD.Active' | translate) : ('MENU.DASHBOARD.inActive' | translate) }}
                </span>
                <button class="btn-view-details" (click)="viewInvestorDetails(investor.id)">
                    <i class="fas fa-eye"></i>
                    {{ 'MENU.DASHBOARD.investor_details' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-12" style="display: flex;justify-content: center;">
          <button type="submit" class="btn " style="background-color: #cca44c !important; color:#fff" (click)="addInvestor()">{{ 'MENU.DASHBOARD.addInvestor' | translate }}</button>
        </div>
    
</div>
</div>

<!-- No Investors Message -->
<div class="no-investors mx-2" *ngIf="employee?.investors && employee.investors.length === 0">
    <div class="no-investors-content ">
        <i class="fas fa-users-slash"></i>
        <h3>{{ 'MENU.DASHBOARD.no_investors_found' | translate }}</h3>
        <p>{{ 'MENU.DASHBOARD.no_investors_for_employee' | translate }}</p>
    </div>

<div class="row mt-2">
        <div class="col-12" style="display: flex;justify-content: center;">
          <button type="submit" class="btn " style="background-color: #cca44c !important; color:#fff" (click)="addInvestor()">{{ 'MENU.DASHBOARD.addInvestor' | translate }}</button>
        </div>
    
</div>
 </div>
  

  <ng-template #loading>
    <p>{{ 'MENU.DASHBOARD.loading_employee_details' | translate }}</p>
  </ng-template>